<script lang="ts">
    import d20Icon from "../../../assets/d20.svg?raw";
</script>

<div class="center-contents-h">
<div class="margin-bottom-1rem">
    <div class="width-1rem">
        {@html d20Icon}
    </div>
    <div class="width-2rem">
        {@html d20Icon}
    </div>
    <div class="width-1rem">
        {@html d20Icon}
    </div>
</div>

</div>